export default __webpack_public_path__ + "static/media/bl_02.a67f7a86.jpg";